<div layout="column" class="layout-column full-height">

  <!--Table-->
  <div class="flex layout-column bringoz-table">

    <!--Table Headers-->
    <div id="header" class="layout-row layout-align-start-center tr text-uppercase">
      <div class="th medium flex-30" translate>Package Type</div>
      <div class="th large flex" translate>Package ID</div>
      <div class="th large flex" translate>Agent Skills</div>
      <div class="th small flex-10" translate>Limit</div>
      <div class="th xsmall"></div>
    </div>

    <!--Table Body-->
    <div class="flex layout-column overflow-auto table-body">

      <app-agent-inventory-settings-table-row *ngFor="let setting of agentInventoryConfig.settings; let index = index"
                                              [setting]="setting"
                                              (onEdit)="onEdit.emit({setting: setting, index: index})"
                                              (onRemove)="onRemove.emit(index)">
      </app-agent-inventory-settings-table-row>

      <!--Empty State-->
      <div *ngIf="!agentInventoryConfig.settings.length"
           class="flex-100 full-height layout-row layout-align-center-center overflow-auto fade-element-in-only">
        <app-empty-state src="assets/images/empty_state/empty_state_dispatching.png"
                         text="No Inventory Configuration Found">

        </app-empty-state>
      </div>

    </div>

  </div>

</div>
